{
	"title": "Declarations",
	"table": {
		"material": "Material",
		"dateOfIssue": "Date of issue",
		"quantity": "Quantity",
		"carbonSavings": "Carbon reductions",
		"status": {
			"title": "Status",
			"TransactionProcessing": "Transaction processing",
			"CreatingDeclaration": "Creating Declaration",
			"GenerationFailed": "Generation failed",
			"ReadyToDownload": "Ready to download"
		}
	},
	"declarationLanguageSelect": {
		"title": "Declaration language",
		"description": "Select a declaration language.",
		"label": "Declaration language",
		"buttonBack": "Back",
		"buttonSave": "Save"
	},
	"downloadAllLanguageSelect": {
		"title": "Declaration languages",
		"descriptionGlobal": "Select a language for all declarations.",
		"descriptionIndividual": "Or set the language for each declaration individually.",
		"label": "Declaration languages",
		"tableHeaderDeclaration": "Declaration (material/date of issue)",
		"tableHeaderLanguage": "Declaration language",
		"buttonBack": "Back",
		"buttonDownload": "Download declarations"
	},
	"declarationActions": {
		"changeLanguage": "Change declaration language",
		"preview": "Preview",
		"download": "Download",
		"transaction": "Transaction",
		"showMoreTransactions": "Show more transactions",
		"languageLabel": "Declaration language",
		"downloadAll": "Download all declarations"
	}
}
